module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "popup-list-box"
  }, [_c('div', {
    staticClass: "popup-list-mask",
    on: {
      "click": function($event) {
        return _vm.hideSelect()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-list-body",
    class: {
      'popup-list-show': _vm.popup, 'popup-list-hide': !_vm.popup
    },
    style: ({
      'height': _vm.height + 'px'
    })
  }, [(_vm.options.searchable) ? _c('div', {
    ref: "search",
    staticClass: "popup-list-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    ref: "input",
    staticClass: "popup-list-input",
    attrs: {
      "type": "search",
      "placeholder": _vm.options.placeholder,
      "size": "20",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.options.paging) ? _c('input', {
    staticClass: "popup-list-search",
    attrs: {
      "type": "button",
      "value": "搜索"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "scroller",
    staticClass: "popup-list-scroller",
    style: ({
      'height': _vm.scrollerHeight + 'px'
    }),
    on: {
      "scroll": function($event) {
        return _vm.onScroll($event)
      }
    }
  }, [_c('ul', {
    ref: "list"
  }, [_vm._l((_vm.filterData), function(item) {
    return [_c('li', {
      class: {
        'popup-list-checked': _vm.isSelected(item)
      },
      on: {
        "click": function($event) {
          return _vm.select(item)
        }
      }
    }, [_vm._v(_vm._s(item.name)), _c('i')])]
  }), _vm._v(" "), (_vm.loading) ? _c('li', {
    staticClass: "popup-list-loading"
  }, [_vm._v("数据加载中...")]) : _vm._e(), _vm._v(" "), (!_vm.hasMore && !_vm.data.length) ? _c('li', {
    staticClass: "popup-list-loading"
  }, [_vm._v("没有更多数据了")]) : _vm._e()], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ebcc69b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/czqui/popup-list/CZQPopupList.vue
// module id = 587
// module chunks = 1